import { sendErrorMessage } from 'utils/messages';

import Upload from 'material/ctas/upload/upload';
import connect from "react-redux/es/connect/connect";




/* ========== ~~~~~~~~~~ LINK : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = () => ({
});

// map actions
const mapDispatchToProps = dispatch => ({
   sendErrorMessage: message => dispatch(sendErrorMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Upload);